import { useRef, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import {
  Avatar,
  Box,
  Button,
  ButtonBase,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Popover,
  Typography
} from '@material-ui/core';
import useAuth from '../../hooks/useAuth';
import CogIcon from '../../icons/Cog';
import UserIcon from '../../icons/User';
import Amplify, { Auth } from 'aws-amplify';
import  {Storage} from "aws-amplify";

const AccountPopover = () => {
  const anchorRef = useRef(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
    const [avatar, setAvatar] = useState('');
   Auth.currentAuthenticatedUser().then(user =>  {
      if (user.attributes.picture){
      getAvatar(user.attributes.picture)
     }
    });
    const getAvatar = async (avatarName) => {
    const user = await Auth.currentAuthenticatedUser();
    await Storage.get(avatarName,{
    level: 'public'}).then(avatar => {
      setAvatar(avatar); 
    }
    )
  }; 
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      handleClose();
      await logout();
      navigate('/');
    } catch (err) {
      console.error(err);
      toast.error('Unable to logout.');
    }
  };

  return (
    <>
      <Box
        component={ButtonBase}
        onClick={handleOpen}
        ref={anchorRef}
        sx={{
          alignItems: 'center',
          display: 'flex'
        }}
      >
        <Avatar
          src={avatar}
          sx={{
            height: 32,
            width: 32
          }}
        />
      </Box>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom'
        }}
        keepMounted
        onClose={handleClose}
        open={open}
        PaperProps={{
          sx: { width: 240 }
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography
            color="textPrimary"
            variant="subtitle2"
          >
            {user.name}
          </Typography>
          {/* <Typography
            color="textSecondary"
            variant="subtitle2"
          >
            Devias
          </Typography> */}
        </Box>
        <Divider />
        <Box sx={{ mt: 2 }}>
          {/* <MenuItem
          //   component={RouterLink}
          //   to="/dashboard/social/profile"
          // >
          //   <ListItemIcon>
          //     <UserIcon fontSize="small" />
          //   </ListItemIcon>
          //   <ListItemText
          //     primary={(
          //       <Typography
          //         color="textPrimary"
          //         variant="subtitle2"
          //       >
          //         Profile
          //       </Typography>
          //     )}
            />
          </MenuItem> */}
          <MenuItem
            component={RouterLink}
            to="/dashboard/account"
          >
            <ListItemIcon>
              <CogIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={(
                <Typography
                  color="textPrimary"
                  variant="subtitle2"
                >
                  Settings
                </Typography>
              )}
            />
          </MenuItem>
        </Box>
        <Box sx={{ p: 2 }}>
          <Button
            color="primary"
            fullWidth
            onClick={handleLogout}
            variant="outlined"
          >
            Logout
          </Button>
        </Box>
      </Popover>
    </>
  );
};

export default AccountPopover;
